// import httpClient from './httpClientDebug'
import httpClient from './httpClient'

const END_POINT = '/customerresources'
// const END_POINT = ''

const CampaignAPI = {
  createBuyerCampaign({ accountId, campaign }) {
    return httpClient.post(`${END_POINT}/${accountId}/buyer-campaigns`, campaign)
  },

  // eslint-disable-next-line no-unused-vars
  editBuyerCampaign({ accountId, campaign }) {
    return httpClient.patch(`${END_POINT}/${accountId}/buyer-campaigns/${campaign.id}`, campaign)
  },

  listBuyerCampaigns(accountId) {
    return httpClient.get(`${END_POINT}/${accountId}/buyer-campaigns`)
  },

  getBuyerCampaign(accountId, id) {
    return httpClient.get(`${END_POINT}/${accountId}/buyer-campaigns/${id}`)
  },

  pauseBuyerCampaign({ accountId, campaignId }) {
    return httpClient.put(`${END_POINT}/${accountId}/buyer-campaigns/${campaignId}/pause`)
  },

  resumeBuyerCampaign({ accountId, campaignId }) {
    return httpClient.put(`${END_POINT}/${accountId}/buyer-campaigns/${campaignId}/resume`)
  },

  pauseSellerCampaign({ campaignId }) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({ id: campaignId })
      }, 3000)
    })
  },

  resumeSellerCampaign({ campaignId }) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({ id: campaignId })
      }, 3000)
    })
  },

  // PUT .../update-bid, 200 with an empty body on success.
  // The request body field is `value` (BuyerCampaignUpdateBidRequest.Value in the backend),
  // NOT `bidAmount` as the published openapi.yaml incorrectly documents it - `value` is a
  // non-nullable float server-side, so a `bidAmount` body silently binds to 0 and 200s.
  //
  // `source` says what made the change, and the campaign-updated event's admin note records it:
  // the campaigns list's suggestion chips send 'Suggestion', so the four-week reviews can tell an
  // accepted suggestion from a hand edit (R48). A hand edit leaves it out of the body altogether.
  updateCampaignBid({ accountId, campaignId, bidValue, source }) {
    return httpClient.put(`${END_POINT}/${accountId}/buyer-campaigns/${campaignId}/update-bid`, {
      campaignId,
      value: bidValue,
      ...(source ? { source } : {})
    })
  },

  // PUT .../update-bid-and-minimum (market intelligence, Slice H): a Static campaign's bid and
  // minimum call length in one write, the minimum turned on. How the campaigns list's chip takes a
  // suggestion that changes the minimum. 200 with an empty body; Static campaigns only. Same `value`
  // and `source` as update-bid above.
  updateCampaignBidAndMinimum({ accountId, campaignId, bidValue, minimumDurationInSeconds, source }) {
    return httpClient.put(`${END_POINT}/${accountId}/buyer-campaigns/${campaignId}/update-bid-and-minimum`, {
      campaignId,
      value: bidValue,
      minimumDurationInSeconds,
      ...(source ? { source } : {})
    })
  },

  // Today's revenue per call per campaign, from ReportingService, counted since midnight in the
  // account's time zone (Pacific when it has none). The numbers come from a shared snapshot that is at
  // most about a minute old, so polling this does not reach Ringba per request.
  // { timeZone, windowStart, windowEnd, unavailable, total: { calls, convertedCalls, revenue, rpc },
  //   rows: [{ campaignId, calls, convertedCalls, revenue, rpc }] }, rpc null when there were no calls,
  // unavailable true when Ringba could not be read and every figure is a placeholder zero.
  getLiveRpc(accountId) {
    return httpClient.get(`/reporting/buyer/${accountId}/campaigns/rpc`)
  }
}

export default CampaignAPI
